import React, { useState } from "react";

/** Builds FAQPage JSON-LD from [[q, a], ...] or [{q, a}, ...]. */
export function faqSchema(items) {
  const list = items.map((i) => (Array.isArray(i) ? { q: i[0], a: i[1] } : i));
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: list.map((x) => ({
      "@type": "Question",
      name: x.q,
      acceptedAnswer: { "@type": "Answer", text: x.a },
    })),
  };
}

/** Accessible accordion. `items` = [[question, answer], ...] */
export default function FAQList({ items, defaultOpen = 0 }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="faq-list">
      {items.map((item, i) => {
        const q = Array.isArray(item) ? item[0] : item.q;
        const a = Array.isArray(item) ? item[1] : item.a;
        const isOpen = open === i;
        return (
          <div key={q} className={`faq-item${isOpen ? " faq-open" : ""}`}>
            <button className="faq-q" onClick={() => setOpen(isOpen ? -1 : i)} aria-expanded={isOpen}>
              <span>{q}</span>
              <span className="faq-icon" aria-hidden="true">{isOpen ? "−" : "+"}</span>
            </button>
            {isOpen && <div className="faq-a">{a}</div>}
          </div>
        );
      })}
    </div>
  );
}
